// @ts-nocheck
/* eslint-disable */

export const initialiseTelium = function () {
  let a = "//tags.tiqcdn.com/utag/theaa/hubcapp/prod/utag.js";
  const b = document;
  const c = "script";
  const d = b.createElement(c);
  d.src = a;
  d.type = "text/java" + c;
  d.async = true;
  a = b.getElementsByTagName(c)[0];
  a.parentNode.insertBefore(d, a);
};
